import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom"; // Added Navigate
import RegisterForm from "./Register";
import LoginForm from "./LoginButton";
import Dashboard from "./dashboard";
import UserDashboard from "./UserDashboard";
import PricingPlans from "./PricingPlans";

function App() {
  const routes = [
    { path: "/register", element: <RegisterForm /> },
    { path: "/login", element: <LoginForm /> },
    { path: "/userDashboard", element: <UserDashboard /> },
    { path: "/plans", element: <PricingPlans /> },
    { path: "/dashboard", element: <Dashboard /> },
    
    // ✅ FIX 1: If user hits exactly "/", send them to /login
    { path: "/", element: <Navigate to="/login" replace /> },

    // ✅ FIX 2: If user types a random URL that doesn't exist, send them to /login
    { path: "*", element: <Navigate to="/login" replace /> },
  ];

  return (
    <Router>
      <Routes>
        {routes.map((r) => (
          <Route key={r.path} path={r.path} element={r.element} />
        ))}
      </Routes>
    </Router>
  );
}

export default App;